import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase';
import { request } from '@/tools/request.ts';
import { Guid } from "guid-typescript";

@Component<Login>({
  components: {
    //
  },
})
export default class Login extends Vue {
  protected baseUrl: string = 'https://us-central1-api-solution.cloudfunctions.net/webApi/api/v1/';
  protected email: string = '';
  protected password: string = '';
  protected dummyUsers: DummyUser[] = [{
    email: 'ouder@lexlibris.nl',
    password: 'secret',
  }, {
    email: 'ouder@parnassys.nl',
    password: 'secret',
  }, {
    email: 'ouder@esis.nl',
    password: 'secret',
  }];
  protected loginError: boolean = false;

  public mounted() {
    //
  }

  protected login() {
    this.dummyUsers.some((item: any) => {
      if (this.email === item.email && this.password === item.password) {
        this.loginError = false;
        this.$router.push('/permissions');
      } else {
        this.loginError = true;
      }
    });
  }

  protected getStyle() {
    if (window.location.href.includes('par')) return 'par';
    else if (window.location.href.includes('esi')) return 'esi';
    else if (window.location.href.includes('bib')) return 'bib';
    else return '';
  }

}
interface DummyUser {
  email: string;
  password: string;
}
